import React from 'react'

export const UploadingMediaLoader = (props) => {
    const uploadPercent = props.uploadPercent
    
  return (
    <div className="flex justify-center items-center right-0 -top-2 fixed z-30 w-full h-full backdrop-blur-sm bg-black/30">
        <div className="absolute p-4 w-full max-w-lg">
            <div className='text-white text-center'>Uploading Photo/Video</div>
            <div className="relative bg-white rounded-lg shadow ">                                    
                <div className="w-full bg-gray-50 rounded-md h-10 my-5">
                    <div className="transition-all h-10 bg-amber-500 text-white my-auto text-xs flex justify-center items-center leading-none rounded-md" style={{width: uploadPercent}}>{uploadPercent}</div>
                </div>
            </div>
        </div>
    </div>
  )
}
